import {DeleteParams, FetchParams, PostParams, PutParams} from '~/utils/thunk-api/type';
import {ThunkApi} from '~/utils/thunk-api';
import {NormalizedUser, UserEntity} from '~/redux/users/types';
import {userSchema} from '~/redux/users/entity-config';
import {ENDPOINTS} from '~/constants';
import {TableState} from '~/types/general';

export interface FetchUserInfoParams extends FetchParams {}

export interface FetchUsersParams extends FetchParams {
  q?: string;
  // isConsentAccepted?: boolean;
}

export interface UpdateUserParams extends PutParams {
  id?: number;
  data: Partial<UserEntity>;
}
export interface AddUserParams extends PostParams {
  data: Partial<UserEntity> & {role_ids?: string[]};
}

export interface DeleteAccountParams extends DeleteParams {}

export interface AddTableStateParams extends PostParams {
  data: {
    tableName: string;
    stateName: string;
    state: TableState;
  };
}

export interface DeleteTableStateParams extends PostParams {
  data: {
    tableName: string;
    stateName: string;
  };
}

const thunk = new ThunkApi<UserEntity, NormalizedUser>('users', userSchema, false);

export const fetchUsers = thunk.fetch<FetchUsersParams>(ENDPOINTS.USERS, 'fetchUsers', {isSnakeCase: false});
export const addUser = thunk.post<AddUserParams>(ENDPOINTS.USERS, 'addUser', {isSnakeCase: false});
export const updateUser = thunk.put<UpdateUserParams>(`${ENDPOINTS.USERS}/:id`, 'updateUser', {isSnakeCase: false});
export const deleteUser = thunk.delete<DeleteParams>(`${ENDPOINTS.USERS}/:id`);

export const addTableState = thunk.post<AddTableStateParams>(ENDPOINTS.TABLE_STATES, 'settings');
export const deleteTableState = thunk.post<DeleteTableStateParams>(ENDPOINTS.TABLE_STATES_DELETE, 'settings/delete');

export const fetchCurrentUserInfo = thunk.fetchOne<FetchUserInfoParams>(ENDPOINTS.CURRENT_USER, 'me/detail', {
  includeApiResponseData: true,
});